/*
  Diskret inglidning för salte-*-sektioner: element med [data-reveal] tonas in
  när de kommer in i bild. Klassen på <html> sätts först här, så utan skript
  (eller med reducerad rörelse) syns allt direkt.
*/
(function () {
  if (window.__salteReveal) return;
  window.__salteReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.hidden) return;
  document.documentElement.classList.add('salte-reveal-ready');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) { observer.observe(el); });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
